var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
export const TOOLTIP_KEYS = {
    alerting: "alerting",
    repeatAlarm: "repeatAlarm",
    sendLowTemp: "sendLowTemp",
    sendHighTemp: "sendHighTemp",
    noNodeCommunication: "noNodeCommunication",
    noApCommunication: "noApCommunication",
    reportingContacts: "reportingContacts",
    serverSettings: "serverSettings",
    eventLogging: "eventLogging",
    /** Node config: mobile numbers / SMS for alarms */
    alarmSms: "alarmSms",
};
// In-flight deduplication: reuse the same promise if a request is already pending
let inflight = null;
const getTooltipTexts = () => __awaiter(void 0, void 0, void 0, function* () {
    if (inflight)
        return inflight;
    inflight = siteX.get("TooltipTexts");
    try {
        const response = yield inflight;
        return response;
    }
    finally {
        inflight = null;
    }
});
const saveTooltipText = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("TooltipTexts/save", payload);
    return response;
});
export const tooltipTextsApi = {
    getTooltipTexts,
    saveTooltipText,
};
